import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auth-help',
  templateUrl: './auth-help.component.html',
  styleUrls: ['./auth-help.component.scss']
})
export class AuthHelpComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
